export default __webpack_public_path__ + "static/SRUS LF735 - Especification Del Producto y Datos Técnicos-a0187458e828b1cf6e1e969c30cdab8d.pdf";